import { abbreviateDate } from '@utils/date';

import { GroupByOption } from 'api/portals/requests';

export const formatDatePortalStatistics = (dateStr: string, groupBy: GroupByOption): string => {
  if (groupBy === 'entireRange') {
    return dateStr;
  }

  const date = new Date(dateStr);

  switch (groupBy) {
    case 'day':
      return date.getDate().toString().padStart(2, '0');
    case 'week':
      return abbreviateDate(date, 'en', 'date-fancy-no-year');
    case 'month':
      return abbreviateDate(date, 'en', 'date-month-short-year');
    default:
      return abbreviateDate(date, 'en', 'date-fancy-no-year');
  }
};

export const getStartOfDay = (date: Date): Date => {
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  return startOfDay;
};

export const getEndOfDay = (date: Date): Date => {
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  return endOfDay;
};
